import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import {
  CHARITY_ONBOARDING_STEPS,
  getCharityOnboardingStepIndex,
  isCharityStripeVerified,
} from '../../../lib/stripeConnect'
import styles from './CharityOnboardingProgress.module.scss'

const TRANSLATION_PREFIX = 'charities.profile.onboarding'

export default function CharityOnboardingProgress({ stripeStatus }) {
  const { t } = useTranslation()

  if (!stripeStatus || isCharityStripeVerified(stripeStatus)) {
    return null
  }

  const currentIndex = getCharityOnboardingStepIndex(stripeStatus)

  return (
    <div className={styles.progress}>
      <p className={styles.title}>{t(`${TRANSLATION_PREFIX}.title`)}</p>
      <ol className={styles.steps}>
        {CHARITY_ONBOARDING_STEPS.map((step, index) => {
          const isComplete = index < currentIndex
          const isCurrent = index === currentIndex
          return (
            <li
              key={step}
              className={[
                styles.step,
                isComplete ? styles.complete : '',
                isCurrent ? styles.current : '',
              ]
                .filter(Boolean)
                .join(' ')}
            >
              <span className={styles.marker} aria-hidden>
                {isComplete ? '✓' : index + 1}
              </span>
              <span className={styles.label}>
                {t(`${TRANSLATION_PREFIX}.steps.${step}`)}
              </span>
            </li>
          )
        })}
      </ol>
    </div>
  )
}

CharityOnboardingProgress.propTypes = {
  stripeStatus: PropTypes.object,
}
